<div style="max-width: 488px;">
  <div class="ui form">
    <dx-combobox #cbBudgetPeriodRef
      controlId="cbBudgetPeriod"
      [formControlInstance]="cbBudgetPeriod"
      [options]="cbBudgetPeriodOptions"
    >
    </dx-combobox>
  </div>
</div>
